import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiChevronDown, mdiChevronUp, mdiHelpCircle } from "@mdi/js";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { MenuWithSubmenu } from "./Menu";

export const HelpsMenu: React.FC<MenuWithSubmenu> = memo(
  ({ handleClick, leftMenuOpen, openSubmenu, user }) => {
    const { t } = useTranslation();

    if (
      !(
        user.roles_names.includes("View Vbuyer Help") ||
        user.roles_names.includes("View Vbuyer")
      )
    ) {
      return null;
    }

    return (
      <>
        <ListItemButton
          // name="helps"
          onClick={() => handleClick("helps")}
          title={t("menu.helps.title")}
        >
          <ListItemIcon sx={{ minWidth: "2rem" }}>
            <Icon icon={mdiHelpCircle} />
          </ListItemIcon>
          {!!leftMenuOpen && (
            <ListItemText
              primary={t("menu.helps.title")}
              slotProps={{
                primary: {
                  sx: {
                    fontSize: 14,
                  },
                },
              }}
              sx={{ whiteSpace: "normal" }}
            />
          )}
          <Icon icon={openSubmenu.helps ? mdiChevronUp : mdiChevronDown} />
        </ListItemButton>
        <Collapse in={openSubmenu.helps} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <HybridRouteListItemButtonLink
              caption="helps general"
              isReact={false}
              name="helps[general]"
              sx={{ pl: 4 }}
              title={t("menu.helps.submenu.general.title")}
              url="/vbuyer/helps"
            >
              <ListItemText
                primary={t("menu.helps.submenu.general.title")}
                slotProps={{
                  primary: { sx: { fontSize: 14 } },
                }}
                sx={{ whiteSpace: "normal" }}
              />
            </HybridRouteListItemButtonLink>

            <HybridRouteListItemButtonLink
              caption="helps invoice and payment procedures"
              isReact={false}
              name="helps[invoiceAndPaymentProcedures]"
              sx={{ pl: 4 }}
              title={t("menu.helps.submenu.invoiceAndPaymentProcedures.title")}
              url="/vbuyer/helps/invoice_and_payment_procedures"
            >
              <ListItemText
                primary={t(
                  "menu.helps.submenu.invoiceAndPaymentProcedures.title",
                )}
                slotProps={{
                  primary: { sx: { fontSize: 14 } },
                }}
                sx={{ whiteSpace: "normal" }}
              />
            </HybridRouteListItemButtonLink>
          </List>
        </Collapse>
      </>
    );
  },
);
